import { useState, useCallback, useEffect, useRef } from 'react';
import rateLimiter from '../utils/rateLimiter';

export const useRateLimit = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLimited, setIsLimited] = useState(false);
  const timerRef = useRef(null);

  const refreshBlockState = useCallback(async () => {
    const result = await rateLimiter.check();
    if (!result.allowed) {
      setErrorMessage(result.reason);
      setIsLimited(true);
    } else {
      setErrorMessage('');
      setIsLimited(false);
    }
  }, []);

  useEffect(() => {
    refreshBlockState();
  }, [refreshBlockState]);

  useEffect(() => {
    if (isLimited) {
      timerRef.current = setInterval(refreshBlockState, 30000);
    }
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isLimited, refreshBlockState]);

  const checkAndIncrement = useCallback(async () => {
    const result = await rateLimiter.checkAndIncrement();
    if (!result.allowed) {
      setErrorMessage(result.reason);
      setIsLimited(true);
      return false;
    }
    return true;
  }, []);

  return { isLimited, errorMessage, checkAndIncrement };
};
